
    import './styles.scoped.css';
    export default {
  "sticky-scrollbar": "awsui_sticky-scrollbar_faqt8_1us5r_5",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_faqt8_1us5r_15",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_faqt8_1us5r_18",
  "sticky-scrollbar-native-invisible": "awsui_sticky-scrollbar-native-invisible_faqt8_1us5r_21"
};
  